import React from 'react';
import { useParams, Switch, Route, useRouteMatch, Link, useLocation } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import SearchPage from './SearchPage';
import AccountViewPage from './AccountViewPage';
import Button from '../components/elements/Button';
import { stringIsNullOrUndefinedOrBlank, isNullOrUndefined } from '../utils/siteFunctions';

const AccountsPage = () =>{
	const match = useRouteMatch();
	const { acctNumber } = useParams<AccountsPageUrlParams>();
	const query = new URLSearchParams(useLocation().search);
	const goToAcct = !stringIsNullOrUndefinedOrBlank(acctNumber);

	return (
		<>
			{/* If in an account, hide the SearchPage instead of unmounting it so the search results remain */}
			<SearchPage showUploadFilesMessage={!isNullOrUndefined(query.get('uploadAccountFiles'))} visible={!goToAcct} />
			{goToAcct &&
				<>
					<Button as={Link} to='/Accounts' basic borderless><Icon name="arrow alternate circle left outline" />Back to Search Results</Button>
					<AccountViewPage acctNumber={acctNumber} />
				</>
			}
		</>
	);

	// if (acctNumber === 'uploadAccountFiles') {
	// 	return <SearchPage showUploadFilesMessage={true} />;
	// }
	// else if (stringIsNullOrUndefinedOrBlank(acctNumber)) {
	// 	return <SearchPage />;
	// }
	// else {
	// 	return (
	// 		<>
	// 			<Button as={Link} to='/Accounts' basic borderless><Icon name="arrow alternate circle left outline" />Back to Search Results</Button>
	// 			<AccountViewPage acctNumber={acctNumber} />
	// 		</>
	// 	);
	// }
};

export interface AccountsPageUrlParams {
	acctNumber: string
}

export default AccountsPage;